module.exports = "#streetSelectType {\n    min-width: 200px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/ref-data-dropdown/ref-data-dropdown.component.css
// module id = ./src/app/shared/components/ref-data-dropdown/ref-data-dropdown.component.css
// module chunks = main